import type { ResourcesContext } from '../resources/resourcesContext';

export interface GarmentRenderable {
  geometryRef?: string;
  occlusionRef?: string;
}

/**
 * Create garment renderable.
 * @param id - Seam ID.
 * @param parent - Seam object.
 */
export function create(): GarmentRenderable {
  return {};
}

/**
 * Dispose Garment renderable.
 * @param self - Garment renderable.
 * @param resources - Resources manager.
 */
export function dispose(self: GarmentRenderable, resources: ResourcesContext) {
  detachGarmentGeometry(self, resources);
  detachGarmentOcclusion(self, resources);
}

// ------ GARMENT GEOMETRY ------

/**
 * Attach garment geometry.
 * @param self - Garment renderable.
 * @param resourceId - Resource ID.
 * @param resources - Resources context.
 */
export function attachGarmentGeometry(
  self: GarmentRenderable,
  resourceId: string,
  resources: ResourcesContext,
) {
  if (self.geometryRef) detachGarmentGeometry(self, resources);
  resources.getRefGarmentGeometry(resourceId);
  self.geometryRef = resourceId;
}

/**
 * Detach garment geometry.
 * @param self - Garment renderable.
 * @param resources - Resources context;
 */
export function detachGarmentGeometry(self: GarmentRenderable, resources: ResourcesContext) {
  if (!self.geometryRef) return;
  resources.retRefGarmentGeometry(self.geometryRef);
  delete self.geometryRef;
}

// ------ GARMENT OCCLUSION ------

/**
 * Attach garment occlusion.
 * @param self - Garment renderable.
 * @param resourceId - Resource ID.
 * @param resources - Resources context.
 */
export function attachGarmentOcclusion(
  self: GarmentRenderable,
  resourceId: string,
  resources: ResourcesContext,
) {
  if (self.occlusionRef) detachGarmentOcclusion(self, resources);
  resources.getRefGarmentOcclusion(resourceId);
  self.occlusionRef = resourceId;
}

/**
 * Detach garment occlusion.
 * @param self - Garment renderable.
 * @param resources - Resources context;
 */
export function detachGarmentOcclusion(self: GarmentRenderable, resources: ResourcesContext) {
  if (!self.occlusionRef) return;
  resources.retRefGarmentOcclusion(self.occlusionRef);
  delete self.occlusionRef;
}
